import {merge} from '#core/utils/config-utils.js';
import {resolveBackground, resolveColor} from '#core/utils/color-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import SWITCH from './switch.palette-schema.yaml';

registerTileSchema(SWITCH);

export function generateSwitch(TILE, {TRUNCATE_LABEL = false} = {}) {
    const BUTTON_BASE = {
        face: {
            ...resolveBackground(TILE.SWITCH_CONTAINER_BG),
            borderColor: TILE.SWITCH_CONTAINER_BORDER_COLOR,
            borderRadius: TILE.SWITCH_BORDER_RADIUS,
            borderStyle: 'solid',
            borderWidth: '1px',
            boxSizing: 'border-box',
        },
        switch: {
            ...resolveBackground(TILE.SWITCH_BUTTON_BG),
            borderRadius: TILE.SWITCH_BORDER_RADIUS,
            borderWidth: '1px', // we need this to handle 1px empty line after switch button as Mojito doesn't give us possibility to set transform or right option
            borderStyle: 'solid',
            boxSizing: 'border-box',
        },
    };

    return {
        mainContainer: {
            itemSpacing: 8,
            style: {
                alignItems: 'center',
            },
        },
        activeLabel: {
            truncate: TRUNCATE_LABEL,
            container: {
                flexGrow: 0,
            },
            style: {
                ...TILE.SWITCH_ON_LABEL_TEXT,
            },
        },
        inactiveLabel: {
            truncate: TRUNCATE_LABEL,
            container: {
                flexGrow: 0,
            },
            style: {
                ...TILE.SWITCH_OFF_LABEL_TEXT,
            },
        },
        disabledLabel: {
            truncate: TRUNCATE_LABEL,
            container: {
                flexGrow: 0,
            },
            style: {
                ...TILE.SWITCH_DISABLED_LABEL_TEXT,
            },
        },
        activeImage: {
            style: {
                width: 8,
                height: 8,
                fill: TILE.SWITCH_ON_ICON_COLOR,
            },
        },
        inactiveImage: {
            src: 'cross',
            style: {
                fill: TILE.SWITCH_OFF_ICON_COLOR,
            },
        },
        spinner: {
            image: {
                style: {
                    fill: TILE.SWITCH_ICON_COLOR,
                },
            },
            style: {
                container: {
                    height: 12,
                    flexBasis: 12,
                },
            },
        },
        style: {
            base: BUTTON_BASE,
            active: {
                switch: {
                    ...resolveBackground(TILE.SWITCH_ON_BUTTON_BG),
                    borderColor: resolveColor(TILE.SWITCH_ON_BUTTON_BG),
                },
            },
            inactive: {
                switch: {
                    ...resolveBackground(TILE.SWITCH_OFF_BUTTON_BG),
                    borderColor: resolveColor(TILE.SWITCH_OFF_BUTTON_BG),
                },
            },
            disabled: merge(BUTTON_BASE, {
                face: {
                    ...resolveBackground(TILE.SWITCH_DISABLED_CONTAINER_BG),
                    borderColor: resolveColor(TILE.SWITCH_DISABLED_CONTAINER_BORDER_COLOR),
                },
                switch: {
                    ...resolveBackground(TILE.SWITCH_DISABLED_BUTTON_BG),
                    borderColor: resolveColor(TILE.SWITCH_DISABLED_BUTTON_BG),
                },
            }),
        },
    };
}
